import { DEFAULT_FLAG } from './EmojiConsts';

const Emoji = ({ unicode = DEFAULT_FLAG.unicode, label = DEFAULT_FLAG.description }) => {
    // Convert hex string to actual emoji
    const emoji = unicode.split('-')
    .map(u => String.fromCodePoint(parseInt(u, 16)))
    .join('');
        
    return (
      <span 
        role="img" 
        aria-label={label}
        className="emoji colorful-emoji"
      >
        {emoji}
      </span>
    );
  };

export default Emoji;
